export default __webpack_public_path__ + "static/media/4-2_image17@2x.b3016a9d.png";